import React, {useEffect} from "react";
import PropTypes from "prop-types";
// Assets
import logo from "../../../../assets/icons/logo.svg";
import Help from "../../../../assets/icons/help.svg";
import telIcone from "../../../../assets/icons/tel.svg";
import "./styles.scss";
import "./style-mobile.scss";
// Utils
import {getBrandValues} from "../../../../utils/getBrandValues";
import {useHistory} from "react-router-dom";
import useWindowDimensions from "../../../../hook/useWindowDimension";

const ColoneChatInfos = ({
                             children,
                             firstname,
                             lastname,
                             tel,
                             rappel,
                             backgroundImgId,
                             cas,
                             openFreeQuestionChatBot,
                             contact,
                         }) => {
    const {width} = useWindowDimensions();
    const history = useHistory();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    console.log("openFreeQuestionChatBot in ColoneCHatInfos", openFreeQuestionChatBot);
    const redirectToOnBoarding = () => {
        if (window["ReactNativeWebView"]) {
            // Envoie un message à la webview si on se trouve sur application mobile
            // Message permettant de rediriger vers le onboarding natif
            window.ReactNativeWebView.postMessage("redirectToOnBoarding");
        } else {
            history.push("/onboarding");
        }
    };
    return (
        width > 599
            ? <div id="colonneInfo">
                <div id="containerMenu">
                    <a href="#"><img
                        src={`${window.location.host.includes("localhost") ? logo : `assets/img/logo-${getBrandValues().suffix}.png`}`}
                        alt="prev&care"/></a>
                    <button onClick={redirectToOnBoarding}>
                        <img src={Help} alt=""/>
                        Aide
                    </button>
                </div>
                <div id="contentInfo">
                    <div id="infoCareManager">
                        <div className="photo-care-manager"
                             style={{backgroundImage: `url(https://adherents.prevandcare.com/uploads/pictures/${backgroundImgId}.jpg)`}}
                             alt="Care Manager"></div>
                        <h1>Votre Care Manager</h1>
                        <h2>{!firstname && !lastname && "-"} {firstname} {lastname}</h2>
                        <h3>{!tel && "-"} {tel}</h3>
                        {rappel &&
                            <div className="callBack">
                                <button className="prune">Demande de rappel</button>
                            </div>
                        }
                    </div>
                    {children}
                </div>
            </div>
            : (!openFreeQuestionChatBot || (openFreeQuestionChatBot == false))
                ? <div id="colonneInfo">
                    <div id="contentInfo">
                        <div className={"chatCaseCMCard"}>
                            <img className="photo-care-manager"
                                 src={`https://adherents.prevandcare.com/uploads/pictures/${backgroundImgId}.jpg`}
                                 alt="photo care manager"/>
                            <div className={"manager-card-infos"}>
                                <h1>{cas.firstname} {cas.name}</h1>
                                <p onClick={() => window.open(cas.tel)}><img src={telIcone}
                                                                             className={"icone"}/>{cas.tel}</p>
                            </div>
                            {contact &&
                                <h2>Votre Care Manager dédié pour {contact.prenom} {contact.nom}</h2>
                            }
                        </div>
                        {children}
                    </div>
                </div>
                : null
        // <div className={"chatCaseCMCard"} style={{display: "none"}}>
        //     <img className="photo-care-manager"
        //          src={`https://adherents.prevandcare.com/uploads/pictures/${cas.idCareManager}.jpg`}
        //          alt="photo care manager"/>
        //     <div className={"manager-card-infos"}>
        //         <h1>{cas.firstname} {cas.name}</h1>
        //         <h2>Votre Care Manager dédié pour{cas.prenom} {cas.nom}</h2>
        //         <p onClick={() => window.open(cas.tel)}><img src={tel}
        //                                                      className={"icone"}/>{cas.tel}</p>
        //     </div>
        // </div>
    );
};

ColoneChatInfos.propTypes = {
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    tel: PropTypes.string,
    rappel: PropTypes.bool,
    backgroundImgId: PropTypes.string,
    children: PropTypes.node,
    cas: PropTypes.object,
    openFreeQuestionChatBot: PropTypes.bool,
    contact: PropTypes.object
};

export default ColoneChatInfos;